import React from 'react'

const FlagIcon: React.FC = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" fill="none" viewBox="0 0 15 18">
		<path
			fill="#3D3C3C"
			d="M9.25 6.875l-.875-1.75h-5.25v-1.12C3.65 3.708 4 3.148 4 2.5 4 1.538 3.212.75 2.25.75S.5 1.538.5 2.5c0 .647.35 1.208.875 1.505v13.37h1.75v-3.5H7.5l.875 1.75H14.5v-8.75H9.25zm3.5 7h-3.5l-.875-1.75h-5.25v-5.25H7.5l.875 1.75h4.375v5.25z"
		/>
	</svg>
)

export default FlagIcon
